<template>
  <PageVenueFilter
    :value="venueId"
    @input="$store.dispatch('pos/general/selectVenueId', $event)"
  >
    <StockCounts v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import StockCounts from "./StockCounts.vue";

export default {
  components: {
    PageVenueFilter,
    StockCounts,
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId",
    }),
  },
};
</script>